"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createModel = void 0;
function patchSelectors(getState, selectorsMap) {
    const newSelectorsMap = {};
    Object.keys(selectorsMap).forEach(selectorName => {
        const selector = selectorsMap[selectorName];
        newSelectorsMap[selectorName] = (...args) => {
            const selectorResult = selector(getState());
            if (selectorResult instanceof Function) {
                return selectorResult(...args);
            }
            return selectorResult;
        };
    });
    return newSelectorsMap;
}
function patchThunks(thunks, scopeName, eventEmitter) {
    return Object.entries(thunks).reduce((newThunks, [thunkName, thunk]) => {
        const scopedThunkName = `${scopeName}/${thunkName}`;
        function patchedThunk() {
            const thunkEventArgs = { thunkName: scopedThunkName, args: Array.from(arguments), result: undefined };
            eventEmitter === null || eventEmitter === void 0 ? void 0 : eventEmitter.emit('onBeforeThunk', thunkEventArgs);
            thunkEventArgs.result = thunk.apply(newThunks, thunkEventArgs.args);
            eventEmitter === null || eventEmitter === void 0 ? void 0 : eventEmitter.emit('onAfterThunk', thunkEventArgs);
            return thunkEventArgs.result;
        }
        patchedThunk.thunkName = scopedThunkName;
        newThunks[thunkName] = patchedThunk;
        return newThunks;
    }, {});
}
function createModel(options, selectorFactory) {
    if (options === undefined) {
        throw new Error(`parameter options is required`);
    }
    if (selectorFactory === undefined) {
        throw new Error(`parameter selectors is required`);
    }
    if (options.initialState === undefined) {
        throw new Error(`initialState is mandatory in options`);
    }
    return {
        modelFactory: (getState) => ({
            getState,
            selectors: patchSelectors(getState, selectorFactory(state => state))
        }),
        registerActions(actionsFactory, registerThunks) {
            return (context) => {
                const actionCreators = {};
                const { scopeName, selectors, getScope } = context;
                const actions = actionsFactory(selectors);
                Object.keys(actions).forEach(actionHandlerName => {
                    const actionType = `${scopeName}/${actionHandlerName}`;
                    actionCreators[actionHandlerName] = (payload) => {
                        var _a, _b;
                        const args = { type: actionType, payload };
                        // invokePluginEvents(plugins, 'onBeforeDispatch', args);
                        (_a = context.eventEmitter) === null || _a === void 0 ? void 0 : _a.emit('onBeforeDispatch', args);
                        const result = context.dispatch(args);
                        (_b = context.eventEmitter) === null || _b === void 0 ? void 0 : _b.emit('onAfterDispatch', { ...args, result });
                        // invokePluginEvents(plugins, 'onAfterDispatch', { ...args, result });
                        return result;
                    };
                });
                const thunkCreators = patchThunks(registerThunks({
                    selectors,
                    getScope,
                    iocContainer: context.iocContainer,
                }, actionCreators), scopeName, context.eventEmitter);
                const reducer = (state, action) => {
                    var _a, _b;
                    if (state === undefined) {
                        return options.initialState;
                    }
                    const actionName = action.type.replace(`${context.scopeName}/`, '');
                    const actionHandler = actions[actionName];
                    if (actionHandler === undefined) {
                        return state;
                    }
                    // const { state: newState } = invokeReducePluginEvents(plugins, 'onBeforeReduce', { state, ...action });
                    const onBeforeReduceArgs = { state, ...action };
                    (_a = context.eventEmitter) === null || _a === void 0 ? void 0 : _a.emit('onBeforeReduce', onBeforeReduceArgs);
                    const reducedState = actionHandler(onBeforeReduceArgs.state, action.payload);
                    const onAfterReduceArgs = { state: reducedState, ...action };
                    (_b = context.eventEmitter) === null || _b === void 0 ? void 0 : _b.emit('onAfterReduce', onAfterReduceArgs);
                    return onAfterReduceArgs.state;
                    // return invokeReducePluginEvents(plugins, 'onAfterReduce', { state: reducedState, ...action }).state;
                };
                return { actions: { ...actionCreators, ...thunkCreators }, getReducer: () => reducer };
            };
        }
    };
}
exports.createModel = createModel;
//# sourceMappingURL=model.js.map